import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getPatientIssuersData,
  addPatientIssuer,
  updatePatientIssuer,
  deletePatientIssuer,
  getPatientIssuerInfo,
} from "../api/patientIssuer"

export const usePatientIssuerData = ({ page, limit, sortBy, filters }) =>
  useQuery({
    queryKey: ["patient-issuers", page, limit, sortBy, filters],
    queryFn: () => getPatientIssuersData({ page, limit, sortBy, filters }),
    retry: false,
  })

export const usePatientIssuerInfo = (issuerId) =>
  useQuery({
    queryKey: ["patient-issuer", issuerId],
    queryFn: () => getPatientIssuerInfo(issuerId),
    enabled: !!issuerId,
  })

export const useAddPatientIssuer = ({ page, limit, sortBy, filters }) => {
  const queryClient = useQueryClient()
  const queryKey = ["patient-issuers", page, limit, sortBy, filters]
  return useMutation({
    mutationFn: addPatientIssuer,
    onError: (err) => console.error(err),
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  })
}

export const useUpdatePatientIssuer = ({
  issuerId,
  page,
  limit,
  sortBy,
  filters,
}) => {
  const queryClient = useQueryClient()
  const queryKey = ["patient-issuers", page, limit, sortBy, filters]
  const singleRestrictedIssuerKey = ["patient-issuer", issuerId]
  return useMutation({
    mutationFn: updatePatientIssuer,
    onError: (err) => console.error(err),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey })
      queryClient.invalidateQueries({ singleRestrictedIssuerKey })
    },
  })
}

export const useDeletePatientIssuer = ({ page, limit, sortBy, filters }) => {
  const queryClient = useQueryClient()
  const queryKey = ["patient-issuers", page, limit, sortBy, filters]
  return useMutation({
    mutationFn: deletePatientIssuer,
    onError: (err) => console.error(err),
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  })
}
